export default __webpack_public_path__ + "static/media/JaguarBG.35aa51ec.png";